// extracted by mini-css-extract-plugin
export default {"cls1":"VeloIconLabel-Container_cls1__f1b-I","cls2":"VeloIconLabel-Container_cls2__ERjMp VeloIconLabel-Container_cls1__f1b-I"};